export const getHorizontalTimelineDelta = ({ deltaX = 0, deltaY = 0, shiftKey = false }) => {
  if (shiftKey && Math.abs(deltaY) >= Math.abs(deltaX)) return deltaY;
  return Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : 0;
};

export const getTimelineWheelZoomIntent = ({
  deltaY = 0,
  altKey = false,
  ctrlKey = false,
  metaKey = false,
}) => {
  if (!deltaY) return null;
  const direction = deltaY < 0 ? 1 : -1;
  if (altKey) return { axis: 'vertical', direction };
  if (ctrlKey || metaKey) return { axis: 'horizontal', direction };
  return null;
};

export const getTimelineKeyboardZoomIntent = ({
  code = '',
  key = '',
  shiftKey = false,
  altKey = false,
  ctrlKey = false,
  metaKey = false,
}) => {
  if (altKey || ctrlKey || metaKey) return null;
  const isZoomIn = code === 'Equal' || code === 'NumpadAdd' || key === '+' || key === '=';
  const isZoomOut = code === 'Minus' || code === 'NumpadSubtract' || key === '-' || key === '_';
  if (!isZoomIn && !isZoomOut) return null;
  return {
    axis: shiftKey ? 'vertical' : 'horizontal',
    direction: isZoomIn ? 1 : -1,
  };
};

export const getAnchoredTimelineScrollLeft = ({
  contentX,
  viewportX,
  scaleRatio,
  clientWidth,
  scrollWidth,
}) => {
  const maxScrollLeft = Math.max(0, scrollWidth - clientWidth);
  const nextScrollLeft = contentX * scaleRatio - viewportX;
  return Math.min(Math.max(nextScrollLeft, 0), maxScrollLeft);
};

export const getTimelineGestureZoomLevel = ({
  startLevel,
  scale,
  sensitivity,
  min,
  max,
}) => {
  const safeScale = Number.isFinite(scale) && scale > 0 ? scale : 1;
  const nextLevel = startLevel + Math.log2(safeScale) * sensitivity;
  return Math.min(Math.max(nextLevel, min), max);
};

export const getPlayheadRevealScroll = ({
  playheadX,
  scrollLeft,
  clientWidth,
  scrollWidth,
}) => {
  const viewportRight = scrollLeft + clientWidth;
  if (playheadX >= scrollLeft && playheadX <= viewportRight) return null;

  const maxScrollLeft = Math.max(0, scrollWidth - clientWidth);
  const centeredScrollLeft = playheadX - clientWidth / 2;
  return Math.min(Math.max(centeredScrollLeft, 0), maxScrollLeft);
};
